import { Injectable, Injector } from '@angular/core';
import { HttpService } from 'projects/core/src/public-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MvcExceptionResponse} from '../../../core/data/mvc-exception-response';


@Injectable({
  providedIn: 'root',
})
export class MiscSnackBarService extends HttpService {

  constructor(
    protected injector: Injector,
    protected snackBar: MatSnackBar
  ) {
    super(injector);
  }

  handleError(error: any, message: string, duration = 5000) {
    if (error instanceof MvcExceptionResponse) {
      this.openErrorSnackBar(error.message, duration);
    } else {
      this.openErrorSnackBar(message, duration);
    }
  }

  openErrorSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      verticalPosition: 'top',
      panelClass: 'misc-error-snackbar',
    });
  }

  openSuccessSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      verticalPosition: 'top',
      panelClass: 'misc-success-snackbar',
    });
  }

  openWarningSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      verticalPosition: 'top',
      panelClass: 'misc-warning-snackbar',
    });
  }


}
